export default __webpack_public_path__ + "static/media/Smoking.2c884d77.svg";